import React, { useState } from "react"
import * as S from "./header-mobile.styles"
import { Box, Collapse, Fade, Stack } from "@mui/material"
import HEADER_ITEMS from "../header-items.json"
import ArrowIcon from "../../../assets/header-arrow.svg"
import Rocket from "../../../assets/rocket.svg"

const HeaderMobile = ({ isOpen }) => {
  const [isOpenItem, setIsOpenItem] = useState("")

  const handleClick = title => {
    if (isOpenItem === title) {
      setIsOpenItem("")
    } else {
      setIsOpenItem(title)
    }
  }

  return (
    <Fade in={isOpen} mountOnEnter unmountOnExit>
      <S.Wrapper>
        <S.LinksWrapper>
          {HEADER_ITEMS.map((item, index) => {
            const Link = item.url ? S.Link : S.StyledText
            return (
              <React.Fragment key={`header-item-${index}`}>
                <S.LinkWrapper>
                  <Link
                    url={item.url}
                    onClick={item.items ? () => handleClick(item.title) : null}
                  >
                    {item.title}
                    {item.items && <ArrowIcon />}
                  </Link>
                  {item?.items && (
                    <Collapse
                      in={isOpenItem === item.title}
                      mountOnEnter
                      unmountOnExit
                    >
                      <Stack
                        spacing={2}
                        className="subitems"
                        marginTop={"1rem"}
                      >
                        {item?.items?.map(({ title, url }, index) => (
                          <S.Link
                            url={url}
                            key={`sub-item-${index}`}
                            className="subitem"
                          >
                            {title}
                          </S.Link>
                        ))}
                      </Stack>
                    </Collapse>
                  )}
                </S.LinkWrapper>
              </React.Fragment>
            )
          })}
        </S.LinksWrapper>
        <Box>
          <S.ContactTitle>Contacts</S.ContactTitle>
          <S.Contact sx={{ marginBottom: "0.5rem" }} href="tel:330-491-4963">
            Phone: 330-491-4963
          </S.Contact>
          <S.Contact href="tel:330-493-5312">Fax: 330-493-5312</S.Contact>
          <S.SubmitBtn
            href="https://earnest.titleoneusa.com/"
            target="_blank"
            className="light"
          >
            Submit earnest money
          </S.SubmitBtn>
          <S.StyledBtn href="/get-started">
            <Rocket />
            Get started now
          </S.StyledBtn>
        </Box>
      </S.Wrapper>
    </Fade>
  )
}

export default HeaderMobile
